import { ESubVerticalNames } from '@constants';
import { IUser } from '@sdk/contracts';

export const getUserSubverticals = (user: IUser | undefined): ESubVerticalNames[] => {
  if (!user || !user?.tags) return [];
  return [...new Set(user.tags.map(tag => tag.vertical))];
};
